<template>
  <div class="login-all">
    <div class="top">
      <center>
        <ul>
          <li>
            <a class="a1">交通金融帮扶操作指南</a>
            <ul class="nav2">
              <li>
                <a
                  target="_blank"
                  href="http://web.9t56.cn/company-financial-assistance.html"
                  >企业操作指南</a
                >
              </li>
              <li>
                <a
                  target="_blank"
                  href="http://web.9t56.cn/owner-financial-assistance.html"
                  >司机车主操作指南</a
                >
              </li>
              <li>
                <a
                  target="_blank"
                  href="http://web.9t56.cn/unowner-financial-assistance.html"
                  >非司机车主操作指南</a
                >
              </li>
            </ul>
          </li>
      		  <li>
      		    <a class="a1">专项贷款操作指南</a>
      		    <ul class="nav2">
      		      <li>
      		        <a
      		          target="_blank"
      		          href="http://web.9t56.cn/owner-loans.html"
      		          >企业操作指南</a
      		        >
      		      </li>
      		      <li>
      		        <a
      		          target="_blank"
      		          href="http://web.9t56.cn/driver-loans.html"
      		          >个人或个体户操作指南</a
      		        >
      		      </li>
      		    </ul>
      		  </li>
          <li>
            <a
              target="_blank"
              href="http://web.9t56.cn/emergency-transportation.html"
              >通行证申领发放操作指南</a
            >
          </li>
          <li>
            <a
              target="_blank"
              href="http://web.9t56.cn/about-yunnan-transport-code.html"
              >关于滇运码</a
            >
          </li>
          <li>
            <a style="color: #000000;"
              target="_blank"
              href="http://web.9t56.cn/about-yunnan-transport-chain.html"
              >关于滇运链</a
            >
          </li>
          <li>
            <a style="color: #000000;"
              target="_blank"
              href="http://web.9t56.cn/operate-guide.html"
              >操作指南</a
            >
          </li>
          <li>
            <a  style="color: #000000;" target="_blank" href="http://web.9t56.cn/contact-us.html"
              >联系我们</a
            >
          </li>
        </ul>
      </center>
    </div>
    <div class="login-all-s">
      <div class="titles">
        <div class="login-title">云南省综合运输区块链生态系统</div>
        <div class="t-english">
          Yunnan integrated transportation block chain ecosystem
        </div>
      </div>
      <div class="login-subheading">
        <div class="subheading-Chinese" style="font-size: 23px">
          金融帮扶线上办理系统
        </div>
        <div
          class="subheading-English"
          style="font-size: 12px; padding-right: 18.8%"
        >
          FINANCIAL SUPPORT ONLINE MANAGEMENT SYSTEM
        </div>
      </div>

      <div class="login-input">
        <div class="user location">
          <span>用户名</span>
          <el-input
            class="user-inp"
            v-model="userName"
            placeholder="请输入用户名"
          ></el-input>
        </div>

        <div class="password location">
          <form>
            <span>密码</span>
            <el-input
              class="user-inp"
              show-password
              v-model="passwords"
              placeholder="请输入密码"
            ></el-input>
          </form>
        </div>

        <div class="code location">
          <form>
            <span>验证码</span>
            <el-input
              class="user-inp-code"
              v-model="code"
              placeholder="请输入验证码"
            ></el-input>
            <el-tooltip
              class="item"
              effect="dark"
              content="看不清?点击图片换一张"
              placement="right"
            >
              <img
                :src="captcha"
                alt="验证码"
                style="width: 100px; vertical-align: bottom"
                @click="getCaptcha"
              />
            </el-tooltip>
          </form>
        </div>

        <div class="enrolls location">
          没有账号？去<span @click="enrollPage">注册</span> 忘记密码？去<span
            @click="forgetPasswordDialogVisible = true"
            >找回密码</span
          >
        </div>

        <div class="login-but" @click="loginBut">登录</div>
      </div>
    </div>
    <div class="login-bottom">
      <div class="explain">
        支持单位：云南省交通运输厅 云南省发展和改革委员会数字经济局
        云南省区块链中心
      </div>
      <div class="explain">
        Powered by：云南九通天下信息技术有限公司
        <!-- 本系统由中国移动BSN区块链服务网络提供区块链技术支持 -->
      </div>
      <div class="explain">
        <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank"
          >滇ICP备2021007610号</a
        >
      </div>
    </div>

    <el-dialog
      title="首次登录，请先修改密码再登录"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="50%"
      @close="closeDialog"
    >
      <div class="cre-all">
        <div class="cre-all-d">
          <span class="cre-all-sp"
            ><span class="cre-xing">*</span>原密码：</span
          >
          <el-input
            show-password
            class="cre-all-inp"
            v-model="editPasswordData.currentPassword"
            placeholder="请输入原密码"
          >
          </el-input>
        </div>
        <div class="cre-all-d">
          <span class="cre-all-sp"
            ><span class="cre-xing">*</span>新密码：</span
          >
          <el-input
            show-password
            class="cre-all-inp"
            v-model="editPasswordData.newPassword"
            placeholder="请输入新密码"
            v-on:input="checkPassword"
          >
          </el-input>
          <span style="color: red" v-if="isCheckPassword"
            >密码不能少于6位，必须包含数字、小写字母、大写字母以及特殊字符</span
          >
        </div>
        <div class="cre-all-d">
          <span class="cre-all-sp"
            ><span class="cre-xing">*</span>确认密码：</span
          >
          <el-input
            show-password
            class="cre-all-inp"
            v-model="editPasswordData.confirmPassword"
            placeholder="请输入确认密码"
          >
          </el-input>
        </div>
        <!-- <div class="cre-all-d" v-if="isjtShow">
          <span class="cre-all-sp"
            ><span class="cre-xing">*</span>联系人：</span
          >
          <el-input
            type="text"
            class="cre-all-inp"
            placeholder="联系人"
            v-model="editPasswordData.emergencyContact"
          >
          </el-input>
        </div>
        <div class="cre-all-d" v-if="isNotShow || isjtShow">
          <span class="cre-all-sp" v-if="isNotShow"
            ><span class="cre-xing">*</span>审批值班电话：</span
          >
          <span class="cre-all-sp" v-if="isjtShow"
            ><span class="cre-xing">*</span>联系电话：</span
          >
          <el-input
            type="text"
            class="cre-all-inp"
            placeholder="请输入电话"
            v-model="editPasswordData.phoneNumber"
          >
          </el-input>
        </div>

        <div class="cre-all-d" v-if="isNotShow || isjtShow">
          <span class="cre-all-sp"
            ><span class="cre-xing">*</span>单位全称：</span
          >
          <el-input
            type="text"
            class="cre-all-inp"
            placeholder="请输入单位全称"
            v-model="editPasswordData.name"
          >
          </el-input>
        </div>
        <div class="cre-all-d" v-if="isNotShow || isjtShow">
          <span class="cre-all-sp"
            ><span class="cre-xing">*</span>负责人手机号：</span
          >
          <el-input
            type="text"
            class="cre-all-inp"
            placeholder="负责人手机号,用于找回密码"
            v-model="editPasswordData.emergencyContactNumber"
          >
          </el-input>
        </div> -->
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="doEditPassword">确定修改</el-button>
      </span>
    </el-dialog>
    <!-- <el-dialog
      title="公告"
      :visible="true"
      :close-on-click-modal="false"
      :show-close="false"
      width="50%"
      @close="closeDialog"
    >
    </el-dialog> -->
    <el-dialog
      title="提示"
      :visible="false"
      :close-on-click-modal="false"
      :show-close="false"
      width="50%"
      @close="closeDialog"
    >
      <div style="font-size: 20px">
        系统升级中：通行证样式调整为与交通运输部样式一致，请稍后再试
      </div>
      <br />
      <div style="font-size: 20px">请按现有流程操作</div>
    </el-dialog>

    <ForgetPassword
      :forgetPasswordDialogVisible.sync="forgetPasswordDialogVisible"
    />
  </div>
</template>
<script>
import ForgetPassword from "@/components/ForgetPassword";
import loginjs from "@/utils/login";
export default {
  components: {
    ForgetPassword,
  },
  data() {
    return {
      userName: "",
      companyName: "",
      passwords: "",
      verification: "",
      dialogVisible: false,
      isCheckPassword: false,
      isNotShow: false,
      isjtShow: false,
      editPasswordData: {
        currentPassword: "",
        newPassword: "",
        passwordResetCode: "",
        confirmPassword: "",
        phoneNumber: "",
        name: "",
        emergencyContactNumber: "",
        emergencyContact: "",
      },
      forgetPasswordDialogVisible: false,
      captcha: "",
      code: "",
      codeId: "",
    };
  },

  created() {
    // 回车键登录
    window.addEventListener("keydown", this.keyDown);
    this.getCaptcha();
  },
  mounted() {
    // console.log("ky-login");
    //localStorage.clear();

    this.deleteCookie("Abp.AuthToken", "/");
  },
  methods: {
    getCaptcha() {
      var that = this;
      var url = `/api/Captcha/GetCaptcha`;
      that.$http
        .get(url)
        .then((res) => {
          if (res.data.success) {
            var rtnResult = res.data.result;
            that.captcha = rtnResult.codeBase64Image;
            that.codeId = rtnResult.codeId;
            that.code = "";
          }
        })
        .catch((err) => {});
    },
    checkPassword() {
      var that = this;
      var passwordReg =
        /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_!@#$%^&*`~()-+=]+$)(?![a-z0-9]+$)(?![a-z\W_!@#$%^&*`~()-+=]+$)(?![0-9\W_!@#$%^&*`~()-+=]+$)[a-zA-Z0-9\W_!@#$%^&*`~()-+=]{6,30}$/;
      if (!passwordReg.test(that.editPasswordData.newPassword)) {
        that.isCheckPassword = true;
      } else {
        that.isCheckPassword = false;
      }
    },
    doEditPassword() {
      var that = this;
      if (!that.editPasswordData.currentPassword) {
        that.$message.error("请输入原密码");
        return;
      }
      if (!that.editPasswordData.newPassword) {
        that.$message.error("请输入新密码");
        return;
      }
      if (!that.editPasswordData.confirmPassword) {
        that.$message.error("请输入确认密码");
        return;
      }
      if (
        that.editPasswordData.confirmPassword !==
        that.editPasswordData.newPassword
      ) {
        that.$message.error("两次密码不一致，请重写输入");
        return;
      }
      var passwordReg =
        /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_!@#$%^&*`~()-+=]+$)(?![a-z0-9]+$)(?![a-z\W_!@#$%^&*`~()-+=]+$)(?![0-9\W_!@#$%^&*`~()-+=]+$)[a-zA-Z0-9\W_!@#$%^&*`~()-+=]{6,30}$/;
      if (!passwordReg.test(that.editPasswordData.newPassword)) {
        that.$message.error(
          "密码不能少于6位，必须包含数字、小写字母、大写字母以及特殊字符"
        );
        return;
      }

      if (that.isNotShow || that.isjtShow) {
        if (!that.editPasswordData.phoneNumber) {
          that.$message.error(
            that.isNotShow ? "请输入审批值班电话" : "请输入联系电话"
          );
          return;
        }
        if (!that.editPasswordData.name) {
          that.$message.error("请输入单位名称");
          return;
        }
        if (!that.editPasswordData.emergencyContactNumber) {
          that.$message.error("请输入负责人手机号，用于找回密码");
          return;
        }
      }
      if (that.isjtShow) {
        if (!that.editPasswordData.emergencyContact) {
          that.$message.error("请输入联系人");
          return;
        }
      }
      // console.log(that.editPasswordData);
      var loading = that.$loading({
        lock: true,
        text: "请稍等...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      that.$http
        .post(
          "/api/services/app/User/FirstChangePassword",
          that.editPasswordData
        )
        .then((res) => {
          if (res.data.success) {
            loading.close();
            that.dialogVisible = false;
            that.$message({
              message: "修改成功，请用新密码重新登录",
              type: "success",
            });
          } else {
            that.dialogVisible = true;
          }
        })
        .catch((err) => {
          loading.close();
          that.dialogVisible = true;
        });
    },
    closeDialog() {
      var that = this;
      that.editPasswordData = {
        currentPassword: "",
        newPassword: "",
        passwordResetCode: "",
        confirmPassword: "",
        phoneNumber: "",
        name: "",
        emergencyContactNumber: "",
        emergencyContact: "",
      };
      that.dialogVisible = false;
      that.isNotShow = false;
      that.isjtShow = false;
    },
    deleteCookie(key, path) {
      let cookieValue = encodeURIComponent(key) + "=";

      cookieValue =
        cookieValue +
        "; expires=" +
        new Date(new Date().getTime() - 86400000).toUTCString();

      if (path) {
        cookieValue = cookieValue + "; path=" + path;
      }
      document.cookie = cookieValue;
    },
    loginBut() {
      localStorage.clear();
      var that = this;
      if (that.userName == "" || that.passwords == "" || that.code == "") {
        that.$message.error("用户名、密码或验证码不能为空");
        return;
      }

      var loading = that.$loading({
        lock: true,
        text: "登录中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      var loginData = {
        userNameOrEmailAddress: that.userName,
        password: that.passwords,
        code: that.code,
        codeId: that.codeId,
      };

      /*
shouldResetPassword: false
tenantId: null
userId: 11673

      */

      that.$http
        .post("/api/TokenAuth/ModifyAuthenticate", loginData)
        .then((res) => {
          // console.log(res);
          if (res.data.success) {
            var rtnResult = res.data.result;
            var accessToken = rtnResult.accessToken;
            var tenantId = rtnResult.tenantId;
            // that.editPasswordData.passwordResetCode =
            //   rtnResult.passwordResetCode;

            localStorage.setItem("accessToken", accessToken);
            localStorage.setItem("userId", tenantId);
            if (tenantId) {
              that.isNotShow = true;
              if (tenantId == 66666) {
                that.isNotShow = false;
                that.isjtShow = true;
              } else {
                that.isjtShow = false;
              }
            } else {
              that.isNotShow = false;
            }

            if (rtnResult.shouldResetPassword) {
              loading.close();
              that.$message({
                message: "首次登录，请先修改密码再登录",
                type: "success",
              });
              that.dialogVisible = true;
              return;
            }

            loginjs.getUserInfo(tenantId).then(
              function(res) {
                loading.close();
                setTimeout(() => {
                  that.$router.push({
                  path: "/home",
                });
                }, 1000);
                
              },
              function(err) {
                loading.close();
                that.getCaptcha();
              }
            );
            
          }
        })
        .catch((err) => {
          loading.close();
          that.getCaptcha();
        });
    },
    keyDown(e) {
      //如果是回车则执行登录方法
      // console.log(e.keyCode)
      if (e.keyCode == 13) {
        console.log("chezhu ");
        this.loginBut();
      }
    },
    destroyed() {
      // 销毁回车键事件
      window.removeEventListener("keydown", this.keyDown, false);
    },

    enrollPage() {
      localStorage.clear();
      this.$router.push({
        name: "chezhu-enroll",
      });
    },

    forgetPassword() {
      var that = this;
      that.forgetPasswordDialogVisible = true;
    },

    closeForgetPasswordDialog() {
      var that = this;
      that.forgetPasswordData = {
        userName: "",
        password: "",
        phoneNumber: "",
        captcha: "",
      };
      that.forgetPasswordDialogVisible = false;
    },
  },
  destroyed(){
      // 销毁回车键事件
      window.removeEventListener("keydown", this.keyDown, false);
  
  }
};
</script>

<style lang="scss" scoped>
@media screen and (max-height: 768px) {
  .login-bottom {
    position: relative !important;
  }
}

@media screen and (min-height: 820px) {
  .login-subheading {
    margin-top: 70px;
  }
}

.top {
  height: 25px;
  width: 100%;
  top: 20px;
  margin: 20px 0 5px 0;
}

.top ul {
  width: auto;
  list-style-type: none;
  white-space: nowrap;
  overflow: hidden;
  margin-left: 5%;
  padding: 0;
}

.top li {
  float: left;
  margin-right: 2%;
  position: relative;
  overflow: hidden;
}

.top li a {
  display: block;
  color: white;
  text-align: center;
  padding: 3px;
  overflow: hidden;
  text-decoration: none;
}

.top li a:hover {
  background-image: linear-gradient(#71ce3d, #51c127, #31b413);
}

.top ul li ul {
  margin-left: -0.2px;
  background-image: linear-gradient(#71ce3d, #51c127, #31b413);
  position: relative;
  display: none;
}

.top ul li ul li {
  float: none;
  text-align: center;
}

.top ul li:hover ul {
  display: block;
}

.login-all {
  position: relative;
  height: 100%;
  width: 100%;
  min-width: 1200px;
  overflow: auto;
  background-image: url("~@/assets/images/background.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;

  .login-all-s {
    min-height: 600px;
  }

  .titles {
    padding: 30px 0;

    .login-title {
      text-align: center;
      font-size: 50px;
      font-weight: bold;
      color: #0078d2;
      -webkit-text-stroke: 1px #ffffff;
      letter-spacing: 5px;
      margin-bottom: 10px;
    }

    .t-english {
      text-align: center;
      font-size: 28px;
      font-weight: bold;
      color: #0078d2;
      -webkit-text-stroke: 1px #ffffff;
    }
  }

  .login-subheading {
    .subheading-Chinese {
      font-size: 34px;
      color: #015f94;
      text-align: right;
      letter-spacing: 10px;
      padding-right: 18%;
    }

    .subheading-English {
      margin-top: 15px;
      padding-right: 18%;
      font-size: 20px;
      color: #015f94;
      text-align: right;
    }
  }

  .login-input {
    padding-top: 60px;
    position: relative;
    height: 350px;
    width: 100%;

    .location {
      position: absolute;
      right: 18%;

      span {
        margin-right: 20px;
      }

      .user-inp {
        width: 300px;
        box-shadow: 0 0 4px #c9cdd2;
      }

      .user-inp-code {
        width: 200px;
        box-shadow: 0 0 4px #c9cdd2;
      }
    }

    .user {
      top: 40px;
    }

    .password {
      top: 110px;
    }

    .code {
      top: 180px;
      display: flex;
      align-items: center;
    }

    .enrolls {
      top: 250px;
      width: 300px;
      text-align: center;
      font-size: 14px;

      span {
        color: #ff0000;
        cursor: pointer;
        padding: 5px;
        margin: 0;
        text-decoration: underline;
      }
    }

    .login-but {
      position: absolute;
      right: 18%;
      color: #ffffff;
      top: 280px;
      height: 40px;
      line-height: 40px;
      border-radius: 3px;
      text-align: center;
      width: 300px;
      font-size: 20px;
      letter-spacing: 5px;
      background-image: linear-gradient(#71ce3d, #51c127, #31b413);
      cursor: pointer;
    }
  }

  .login-bottom {
    width: 100%;
    height: 75px;
    position: absolute;
    bottom: 0;
    margin-bottom: 20px;
    left: 0;

    .explain {
      text-align: center;
      color: #000000;
      line-height: 25px;
      font-size: 14px;
      letter-spacing: 2px;
    }
  }
}

.cre-all {
  display: inline-block;
  width: 100%;

  .cre-all-d {
    margin: 0 3% 30px 0;

    .cre-all-sp {
      font-size: 14px;
      color: #333333;
      margin-bottom: 10px;
      display: inline-block;
      float: left;
      line-height: 40px;

      .cre-xing {
        color: #ff0000;
      }
    }

    .cre-all-inp {
      width: 100%;
    }
  }
}
</style>

<style scoped>
.nav1 {
  width: 400px;
  height: 50px;
  /* 让盒子在浏览器窗口居中方便观看 */
  margin: 100px auto;
}

.nav1 > li {
  /* 让一级导航栏左浮动 */
  float: left;
}

.nav1 a {
  /* 将a转为块级元素 */
  display: block;
  width: 100px;
  height: 50px;
  font: 12px/50px "微软雅黑";
  color: black;
  text-align: center;
  border: 1px solid #bbb;
  box-sizing: border-box;
}
.nav2 {
  /* 隐藏元素 */
  display: none;
}
/* 当鼠标滑过li的时候 让元素显示 */
.nav1 li:hover .nav2 {
  display: block;
}
.nav1 > li:hover .a1 {
  background-color: #333;
  color: #fff;
}
a:hover {
  background-color: #333;
  color: #fff;
}
</style>
